import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
  Fade,
  Box,
} from '@mui/material';
import { Button, Card, Typography } from 'bso-ui';
import { ArrowForward } from '@mui/icons-material';
import CustomNavLink from 'components/CustomNavLink/CustomNavLink';

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%',
    padding: theme.spacing(10)
  },
  title: {
    textAlign: 'center',
    alignItems: 'center',
    fontSize: 48,
    fontWeight: 300,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
  },
  subtitle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center',
    },
    paddingTop: theme.spacing(10),
  },
}));

const Forbidden = () => {
  const classes = useStyles();

  return (
    <div>
      <Fade
        in
        mountOnEnter
        timeout={400}
        unmountOnExit
      >
        <div>
          <Card color="gradient">
            <Box p={3}>
              <Card color="white">
                <div
                  className={classes.form}
                >
                  <Typography
                    className={classes.title}
                    data-testid="welcome-message"
                    variant="h1"
                    style={{ fontSize: 140 }}
                  >
                    403
                  </Typography>
                  <div className={classes.subtitle}>
                    <Typography variant="h3">
                      You do not have permission to view this page.
                    </Typography>
                    <Button
                      variant="cta"
                      state="outlined"
                      color="primary"
                      endIcon={<ArrowForward />}
                      component={CustomNavLink}
                      to="/"
                      style={{ marginTop: 16 }}
                    >
                      Back to home page
                    </Button>
                  </div>
                </div>
              </Card>
            </Box>
          </Card>
        </div>
      </Fade>
    </div>
  );
};

export default Forbidden;
